
<template-base
    title      = "Vorlage"
    :items     = "templates"
    :variables = "variables"
    :create-allowed = "true"
    :settings-admin = "isSettingsAdmin"
    @save      = "onSave"
    @create    = "onCreate"
    @remove    = "onRemove"
    ref        = "base"
>
    <template v-slot:ident="data" >
        <v-row class="no-frame mt-0">
            <v-col class="no-frame pr-2 col-9">
                <f-read-only-field
                    v-if   = "data.item.standard"
                    label  = "Name"
                    :value = "data.item.name"
                    style  = "margin-top: 5px"
                />
                <v-text-field
                    v-if="!data.item.standard"
                    label          = "Name"
                    v-model        = "data.item.name"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    :readonly      = "!isSettingsAdmin"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <v-select
                    v-if="signatures"
                    :items="signatures"
                    item-value="id"
                    item-text="name"
                    label="Signatur"
                    return-object
                    v-model="data.item.signature"
                    :readonly      = "!isSettingsAdmin"
                />
            </v-col>
        </v-row>
        <v-row class="no-frame">
            <v-col class="no-frame">
                <v-text-field
                    label="Betreff"
                    v-model        = "data.item.subject"
                    autocomplete   = "off"
                    autocorrect    = "off"
                    autocapitalize = "off"
                    spellcheck     = "false"
                    :readonly      = "!isSettingsAdmin"
                />
            </v-col>
        </v-row>
    </template>
</template-base>
